import { client } from "../client/client";

export const getAllGuarantors = async (
  page,
  limit,
  from,
  to,
  search,
  status
) => {
  try {
    const params = new URLSearchParams();

    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (from) params.append("createdFrom", from);
    if (to) params.append("createdTo", to);
    if (search) params.append("q", search);
    if (status) params.append("status", status);

    const response = await client.get(`/guarantors?${params.toString()}`);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getGuarantor = async (id) => {
  try {
    const response = await client.get(`/guarantors/${id}`);
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
